import { alternativeCheckout } from '@site/components/PathNavigation'

const whitelistReferers = process.env[ 'GATSBY_REDIRECT_WHITELIST_REFERERS' ]?.split( ',' ) || []

export function getAlternativeCheckoutRedirectURL( referrer: string, queryProps: Record<string, string | null> ): string | null {
  if ( process.env[ 'GATSBY_ACTIVE_ENV' ] !== 'prd' ) {
    return null
  }

  if ( queryProps[ 'category' ] && queryProps[ 'plan' ] ) {
    return null
  }

  const isWhitelistReferer = whitelistReferers.some( whitelistReferrer => whitelistReferrer && referrer.includes( whitelistReferrer ) )

  if ( isWhitelistReferer ) {
    return null
  }

  return alternativeCheckout
}
